// src/components/BoardOfEd/components/Program2200.jsx
import React from "react";
import { ProgramBudget } from "../../../../budget/model/program/ProgramBudget.jsx";

export const PROGRAM_2200_CONFIG = {
  fullName: "UTILITIES",
  docId: "2200",

  fieldDefs: [
    // UTILITIES
    {
      key: "water",
      label: "Water",
      valueType: "currency",
      sources: [{ block: "Utilities", key: "Water" }],
      group: "utilities",
      defaultVisible: false,
    },
    {
      key: "sewer",
      label: "Sewer",
      valueType: "currency",
      sources: [{ block: "Utilities", key: "Sewer" }],
      group: "utilities",
      defaultVisible: false,
    },
    {
      key: "power",
      label: "Power",
      valueType: "currency",
      sources: [{ block: "Utilities", key: "Power" }],
      group: "utilities",
      defaultVisible: false,
    },
    {
      key: "gasMisc",
      label: "Gas, Misc.",
      valueType: "currency",
      sources: [{ block: "Utilities", key: "Gas, Misc." }],
      group: "utilities",
      defaultVisible: false,
    },
    {
      key: "heatOilGas",
      label: "Heat (Oil/Gas)",
      valueType: "currency",
      sources: [{ block: "Utilities", key: "Heat (Oil/Gas)" }],
      group: "utilities",
      defaultVisible: false,
    },
    {
      key: "energyConservation",
      label: "Energy Conservation Initiatives",
      valueType: "currency",
      sources: [{ block: "Utilities", key: "Energy Conservation Initiatives" }],
      group: "utilities",
      defaultVisible: false,
    },
    {
      key: "telephone",
      label: "Telephone",
      valueType: "currency",
      sources: [{ block: "Utilities", key: "Telephone" }],
      group: "utilities",
      defaultVisible: false,
    },
    {
      key: "telecommunications",
      label: "Telecommunications",
      valueType: "currency",
      sources: [{ block: "Utilities", key: "Telecommunications" }],
      group: "utilities",
      defaultVisible: false,
    },
    {
      key: "telecomRepair",
      label: "Telecom Repair/Mntc",
      valueType: "currency",
      sources: [
        { block: "Utilities", key: "Telecom Repair/mntc" },
        { block: "Utilities", key: "Telecom Repair/Mntc" },
      ],
      group: "utilities",
      defaultVisible: false,
    },
    {
      key: "telecomNewEquip",
      label: "Telecommunications/New Equipment",
      valueType: "currency",
      sources: [
        { block: "Utilities", key: "Telecommunications/new Equipment" },
        { block: "Utilities", key: "Telecommunications/New Equipment" },
      ],
      group: "utilities",
      defaultVisible: false,
    },
  ],

  tables: [
    {
      id: "approved",
      title: "Approved Budget",
      sectionKey: "Approved",
      fields: [
        "water",
        "sewer",
        "power",
        "gasMisc",
        "heatOilGas",
        "energyConservation",
        "telephone",
        "telecommunications",
        "telecomRepair",
        "telecomNewEquip",
      ],
      columnStyles: {
        year: { width: "100px", minWidth: "100px" },
        water: { minWidth: "90px" },
        sewer: { minWidth: "90px" },
        power: { minWidth: "110px" },
        gasMisc: { minWidth: "110px" },
        heatOilGas: { minWidth: "130px" },
        energyConservation: { minWidth: "190px" },
        telephone: { minWidth: "110px" },
        telecommunications: { minWidth: "150px" },
        telecomRepair: { minWidth: "150px" },
        telecomNewEquip: { minWidth: "210px" },
      },
    },
    {
      id: "actual",
      title: "Actual Spending",
      sectionKey: "Actual",
      fields: [
        "water",
        "sewer",
        "power",
        "gasMisc",
        "heatOilGas",
        "energyConservation",
        "telephone",
        "telecommunications",
        "telecomRepair",
        "telecomNewEquip",
      ],
      columnStyles: {
        year: { width: "100px", minWidth: "100px" },
        water: { minWidth: "90px" },
        sewer: { minWidth: "90px" },
        power: { minWidth: "110px" },
        gasMisc: { minWidth: "110px" },
        heatOilGas: { minWidth: "130px" },
        energyConservation: { minWidth: "190px" },
        telephone: { minWidth: "110px" },
        telecommunications: { minWidth: "150px" },
        telecomRepair: { minWidth: "150px" },
        telecomNewEquip: { minWidth: "210px" },
      },
    },
  ],
};

export function Program2200(props) {
  return (
    <ProgramBudget programId="2200" config={PROGRAM_2200_CONFIG} {...props} />
  );
}
